export default "__VITE_ASSET__Bo3n3QrR__"